import React from 'react';
import SinglePost from './SinglePost';
import styled from '@emotion/styled';
import { Breakpoints, Space } from './Styles';

const RelatedPostsDiv = styled.div`
  display: flex;
  padding: ${Space[32]} 0;
  align-items: stretch;
  justify-content: space-around;

  @media (max-width: ${Breakpoints.lg}) {
    flex-direction: column;
  }
`;

const Header = styled.h2`
  font-size: ${Space[32]};
  font-weight: bold;
  text-align: center;
  margin-bottom: ${Space[16]};
`;

const RelatedPosts = ({ relatedPosts }) => {
  return (
    <div>
      <Header>Related Posts</Header>
      <RelatedPostsDiv>
        {relatedPosts.map(relatedPost => {
          return <SinglePost {...relatedPost.node} showExcerpt isRelatedPost />;
        })}
      </RelatedPostsDiv>
    </div>
  );
};

export default RelatedPosts;
